// extracted by css-extract-rspack-plugin
export default {"toolName":"l9zRWa7wpcob_i3S"};